import React, {Component} from 'react';
import moment from 'moment';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet"
import {number, PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import VoteItem from '../Utils/VoteItem'
import PrivacyModal from '../Utils/PrivacyModal'
import PollyEditModal from '../Utils/PollyEditModal'
import Avatar from '../../images/avatar.svg'
import PostAvatar from '../Post/PostAvatar'
import InfoModal from '../../components/Utils/InfoModal';
import {fetchFollowings, onFollow, onUnFollow} from '../../actions/following';
import {createSingleVote, fetchVotesList} from '../../actions/votes';
import {addComments, fetchNewsList, fetchPollyCommentList, fetchRelatedPollicies} from '../../actions/pollypage';
import {
    ABUSE,
    COMMENT_MAX_CHARACTER,
    FETCH_MENTION_FINISHED,
    FETCH_MENTION_STARTED,
    POLLY_FOLLOW,
    POLLY_PAGE_LOADED,
    POLLY_PAGE_UNLOADED,
    POLLY_UN_FOLLOW,
} from '../../constants/actionTypes';
import agent from "../../agent";
import {getLabel,languageData} from '../../language'
import {Modal} from 'react-bootstrap';
import UserModal from "../AuthModal/index"
import VoterLocationsTab from "../Settings/VoterLocationsTab";
import PrivacySettingsTab from "../Settings/PrivacyTab";
import {fetchUser} from "../../actions/user";
import SharePostModal from "../Party/SharePostModal";
import Slider from "react-rangeslider";
import up_vote from "../../images/up_1.svg";
import undecided_vote from "../../images/maybe_1.svg";
import down_vote from "../../images/down_1.svg";
import Chat_icon from '../../images/Chat_icon.png'
import {APP_CONFIG} from "../../appconfig";
import ChatModal from "./ChatModal";
import {message, Modal as antdModel, Popconfirm} from "antd";
const defaultAvatar = APP_CONFIG.defaultAvatar;
const apiPath = APP_CONFIG.apiPath;

const mapStateToProps = state => ({
    currentUser: state.common.currentUser,
    userId: state.common.currentUser ? state.common.currentUser.id : null,
    followees: state.followees,
    persons: state.followees.persons,
    currentPollyId: state.page.page.personID,
    votes: state.votes.votes,
    voteError: state.votes.voteError,
    vote: state.votes.vote,
    commentsList: state.polly.commentsList,
    newsList: state.polly.newsList,
    relatedPolliciesList: state.polly.relatedPolliciesList,
    userInfo: state.polly && state.polly.userInfo,
    isAuthorized: state.auth && state.auth.isAuthorized,
    mention: state.mention && state.mention.mentions || [],
    hasVoterLocations: state.common.currentUser,
    polly: state.page.page || {},
    anonymousMode: state.user.anonymousMode
});

const mergeProps = (stateProps, dispatchProps,props) => {
    const {currentUser} = stateProps;
    const {dispatch} = dispatchProps;
    const userName = currentUser ? currentUser.userName : '';
    return Object.assign({}, stateProps, {
        ...dispatchProps,
        currentUser: stateProps.currentUser,
        userId: stateProps.userId,
        followees: stateProps.followees,
        persons: stateProps.persons,
        currentPollyId: stateProps.currentPollyId,
        votes: stateProps.votes,
        voteError: stateProps.voteError,
        vote: stateProps.vote,
        commentsList: stateProps.commentsList,
        newsList: stateProps.newsList,
        relatedPolliciesList: stateProps.relatedPolliciesList,
        userInfo: stateProps.userInfo,
        isAuthorized: stateProps.isAuthorized,
        mention: stateProps.mention || [],
        hasVoterLocations: stateProps.hasVoterLocations,
        polly: stateProps.polly || {},
        commentId: props.location.state || "",
        fetchUser: () => dispatch(fetchUser(userName))
    })
};

const mapDispatchToProps = (dispatch) => ({
    onFollow: dispatch(onFollow),
    onUnFollow: dispatch(onUnFollow),
    fetchFollowings: dispatch(fetchFollowings),
    createSingleVote: dispatch(createSingleVote),
    fetchVotesList: dispatch(fetchVotesList),
    fetchPollyCommentList: dispatch(fetchPollyCommentList),
    fetchRelatedPollicies: dispatch(fetchRelatedPollicies),
    fetchNewsList: dispatch(fetchNewsList),
    addComments: dispatch(addComments),
    pollyFollow: (payload) => dispatch({
        type: POLLY_FOLLOW,
        payload
    }),
    pollyUnFollow: (payload) => dispatch({
        type: POLLY_UN_FOLLOW,
        payload
    }),
    onLoad: payload => dispatch({
        type: POLLY_PAGE_LOADED,
        payload
    }),
    abuse: payload => dispatch({
        type: ABUSE,
        payload: agent.Abuse.setAbuse(payload)
    }),
    onUnload: () =>
        dispatch({type: POLLY_PAGE_UNLOADED}),
    getMentionUsers: () => {
        dispatch({type: FETCH_MENTION_STARTED});
        agent.Mentions.get().then(res => {
            let usersFetched = [];
            if (res) {
                res.map(item => {
                    usersFetched.push({
                        id: item.userName || item.id.toString(),
                        display: item.userName,
                        displayName: item.displayName,
                        avatar: `${apiPath}/user/${item.userName}/picture`
                    });
                })
            }
            dispatch({type: FETCH_MENTION_FINISHED, payload: usersFetched});
        }, err => {
        })
    },
});
export class PollyPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMyPostsAndComments: '',
            viewMyPostsAndCommentsDefault: '',
            replyMyPostsAndComments: '',
            viewMyVotes:'',
            viewMyVotesDefault: '',
            prevVote: {personId: '', ability: 0, vision: 0, dateCreated: ''},
            curVote: {personId: props.polly && props.polly.personID, ability: 0, vision: 0},
            currentUser: this.props.currentUser,
            isFollowing: false,
            privacyModal: false,
            followLevel: props.polly && props.polly.followLevel || '',
            voteItem: '',
            commentList: [],
            isWatch: 1,
            isWatchClosely: 2,
            followeeType: 'P',
            currentPolly: {},
            polliesComment: '',
            downVote: 0,
            upVote: 0,
            mayBe: 0,
            vote: '',
            isAuthModalOpen: false,
            showShare: false,
            voterLocation: '',
            showChat: false,
            isFinal: false,
            reaction: [],
            pollyEditModal: false,
            showCommentErrorMessage: true,
            chars_left: 0,
            chars_leftBody:0,
            max_char: COMMENT_MAX_CHARACTER,
            inTheirOwnWords:[],
            isNewsList: false
        }
        this.onWatchClick = this.onWatchClick.bind(this);
        this.onWatchCloselyClick = this.onWatchCloselyClick.bind(this);
        this.watch = this.watch.bind(this);
        this.onUnFollow = this.onUnFollow.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.onVoteSubmit = this.onVoteSubmit.bind(this);
        this.getVotesById = this.getVotesById.bind(this);
        this.privacyModal = this.privacyModal.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onComment = this.onComment.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
    }

    componentWillMount() {
        const currentUser = this.props.currentUser;
        if (currentUser) {
            this.props.fetchFollowings(currentUser.id)
            this.setState({
                viewMyPostsAndComments: currentUser ? (parseInt(currentUser.viewMyPostsAndComments) === 1 ? 2 : currentUser.viewMyPostsAndComments) : null,
                replyMyPostsAndComments: currentUser ? currentUser.replyMyPostsAndComments : null,
                viewMyVotes: currentUser ? (parseInt(currentUser.viewMyVotes) === 1 ? 2 : currentUser.viewMyVotes) : null,
                viewMyPostsAndCommentsDefault: currentUser ? currentUser.viewMyPostsAndComments : null,
                viewMyVotesDefault: currentUser ? currentUser.viewMyVotes : null,
            })
        }

        if (this.props.polly && this.props.polly.personID) {
            const polliesIDs = this.props.polly.personID
            this.props.fetchRelatedPollicies(polliesIDs);
            this.props.fetchPollyCommentList(polliesIDs);
        }
        this.props.getMentionUsers();
    }

    componentDidMount() {
        this.setState({
            reaction: []
        })
        if (this.props.commentsList) {
            this.props.commentsList.map((item) => {
                item.abuse.myAbuse.map((items) => {
                    this.setState(prevState => ({
                        reaction: [
                            ...prevState.reaction,
                            {id: item.id, name: items.abuseType}
                        ]
                    }))
                })
            })
        }

        if (this.props.polly && this.props.polly.personID) {
            agent.Pollies.getAveragesVotes(this.props.polly.personID).then(res => {
                if (res) {
                    this.setState({
                        downVote: res.votesAgainst || 0,
                        upVote: res.votesFor || 0,
                        mayBe: res.votesUnspecified || 0
                    })
                }
            }, err => {
                console.log(err.message)
            })
        }
        if(this.props?.commentId){
            const elements = document.querySelector(`[data-id="${this.props?.commentId}"]`);
            if (elements){
                elements.scrollIntoView({ behavior: "smooth" })
            }
        }

        if(this.props.voteItem && this.props.voteItem.viewMyVotes){
            this.setState({
                viewMyVotes:parseInt(this.props.voteItem.viewMyVotes) === 1 ? 2 : this.props.voteItem.viewMyVotes
            })
        }else{
            this.setState({
                viewMyVotes:this.props.currentUser ? this.props.currentUser.viewMyVotes:localStorage.getItem("viewMyVotes")
            })
        }
        const post = this.props.polly?.posts?.length && this.props.polly?.posts;
        const topic = this.props.polly?.TopicStance?.length && this.props.polly?.TopicStance;
        post?.length && post.map((item,index)=>{
            post[index].urlCheck = 'posts'
        });
        topic?.length && topic.map((item,index)=>{
            topic[index].urlCheck = 'topicstance'
        });
        const combineData = post?.length && topic?.length ? [...post,...topic] : post?.length ? [...post] : topic?.length ? [...topic] : [];
        let sortedData =  combineData?.length && combineData.sort((a,b)=>{
            return (a.created < b.created) ? 1 : ((a.created > b.created) ? -1 : 0);
        });
        this.setState({
            inTheirOwnWords : sortedData
        })
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevProps !== this.props) && this.props?.commentsList) {
            const currentCommentDetail = await (this.props?.commentsList || []).find((ele) => ele.id === this.props?.commentId);
            if (!!currentCommentDetail) {
                const elements = document.querySelector(`[data-id="${this.props?.commentId}"]`);
                const y = elements?.getBoundingClientRect()?.top + window.pageYOffset ;
                if (elements) {
                    // elements.scrollIntoView({behavior: "smooth", top: 100})
                    window.scrollTo( {behavior: "smooth", top: y - 100  })
                }
            } else {
                if(this.state.showCommentErrorMessage && this.props?.commentId){
                    setTimeout(() => {
                        message.error(getLabel(335));
                    }, 1000);
                }
                this.setState({
                    ...this.state,
                    showCommentErrorMessage: false
                });
            }
        }


    }

    async componentWillReceiveProps(nextProps) {
        this.setState({
            reaction: []
        })
        if (this.props.currentUser){
            await agent.UserLocations.get().then(res => {
                if (res && res.length) {
                    this.setState({
                        voterLocation: res[0] && res[0].id,
                        isVoterLocation:true
                    })
                }
            })
        }
        if (this.props.commentsList) {
            this.props.commentsList.map((item) => {
                item.abuse.myAbuse.map((items) => {
                    this.setState(prevState => ({
                        reaction: [
                            ...prevState.reaction,
                            {id: item.id, name: items.abuseType}
                        ]
                    }))
                })
            })
        }
        if(this.props.currentUser && nextProps.persons) {
            let isFollowing = false;
            let pollyPerson = null;
            nextProps.persons.map(item => {
                if (item.personID == this.props.currentPollyId) {
                    isFollowing = true;
                    pollyPerson = item;
                }
            });
            this.setState({isFollowing: isFollowing, currentPolly: pollyPerson})
        }
        if (this.props.isAuthorized && !this.state.isNewsList) {
            this.setState({
                isNewsList: true
            })
            const polliesIDs = this.props.polly.personID;
            this.props.fetchVotesList(polliesIDs);
            this.props.fetchNewsList(this.props.polly.displayName);
        }
        if (nextProps.votes) {
            const voteItem = this.getVotesById(this.props.polly.personID, nextProps.votes);
            this.setState({
                prevVote: voteItem,
                polliesComment: voteItem && voteItem.comment,
                vote: voteItem && voteItem.vote,
                isFinal: voteItem && voteItem.isFinal,
            })
        }

        if (nextProps.vote && nextProps.vote.id) {
            this.setState({
                isVote: nextProps.vote.id
            })
        }

        if (nextProps.votes && this.state.isVote) {
            const voted = nextProps.votes.find(res => {
                return res.id === this.state.isVote ? true : false
            })
            if (voted) {
                this.setState({
                    showShare: true
                })
            }
        }
        const staticDescriptionElement = document.getElementById('main-description');

        if (staticDescriptionElement) {
            if (this.props.polly.seoDescription) {
                staticDescriptionElement.remove();
            }
        }
    }

    componentWillUnmount() {
        this.props.onUnload();
        const newStaticDescriptionElement = document.createElement('meta');
        newStaticDescriptionElement.id = 'main-description';
        newStaticDescriptionElement.name = 'description';
        newStaticDescriptionElement.content = 'A new social platform dedicated to politics. We\'re taking the good ingredients from the current set of social networks and adding a few new ones to make a unique experience. We\'re just getting started so this is just the beginning.';
        document.head.appendChild(newStaticDescriptionElement);
    }

    handleOnChange(e, field) {
        this.setState({...this.state, curVote: {...this.state.curVote, [field]: e}});
        if (!this.state.voterLocation && this.props.currentUser) {
            this.setState({
                isVoterLocationModal: true,
            })
        } else {
            this.setState({isAuthModalOpen: !this.props.currentUser});
        }
    }

    onLikeSubmit = (e) => {
        if(this.props.currentUser !== undefined){
            const {viewMyVotes, viewMyProfile, viewMyPostsAndComments, sendMeDirectMessage, replyMyPostsAndComments, mentionMe} = this.props.currentUser
            let vote = ''
            if (e.target.name === "downVote") {
                vote = 'A'
            } else if (e.target.name === "upVote") {
                vote = 'F'
            } else if (e.target.name === "mayBe") {
                vote = 'U'
            }
            if (!this.state.voterLocation && this.props.currentUser) {
                this.setState({
                    vote, isVoterLocationModal: true,
                })
            } else {
                this.setState({vote, isAuthModalOpen: !this.props.currentUser});
            }

            if(viewMyVotes === 0 || viewMyProfile === 0 || viewMyPostsAndComments === 0 || sendMeDirectMessage === 0 || replyMyPostsAndComments === 0 || mentionMe === 0){
                this.setState({
                    isPrivacyModal: true,
                })
            }
        }else{
            this.setState({isAuthModalOpen: !this.props.currentUser});
        }
    }

    openVotarLocationModel = () => {
        this.setState({
            isVoterLocationModal: false
        })
    }

    openPrivacyModel = () => {
        this.setState({
            isPrivacyModal: false
        })
    }

    onVoteSubmit() {
        if (this.state.vote !== '' && this.state.vote !== undefined) {
            const {viewMyVotes, viewMyProfile, viewMyPostsAndComments, sendMeDirectMessage, replyMyPostsAndComments, mentionMe} = this.props.currentUser
            if (viewMyVotes === 0 || viewMyProfile === 0 || viewMyPostsAndComments === 0 || sendMeDirectMessage === 0 || replyMyPostsAndComments === 0 || mentionMe === 0) {
                this.setState({
                    isPrivacyModal: true,
                })
                return false
            }
            const curVote = this.state.curVote;
            curVote.viewMyVotes = this.state.viewMyVotes || 0;
            curVote.viewMyVotesDefault = this.state.viewMyVotesDefault || 0;
            curVote.polliesComment = this.state.polliesComment;
            curVote.vote = this.state.vote;
            curVote.isFinal = this.state.isFinal;
            this.props.createSingleVote({...curVote}, this.props.polly.personID);
            this.setState({...this.state, curVote: {...curVote}});
        }else{
            antdModel.warning({
                title: getLabel(333),
                zIndex: 5000
            });
        }
    }

    getVotesById(personID, votes) {
        if (votes && !votes.status) {
            return votes.find(item => item.personID === personID && item.authorId === this.props.currentUser.id && moment(item.dateCreated).isBetween(moment().startOf('day'), moment().endOf('day')));
        }
    }

    getYesterDayVotesById(personID, votes) {
        if (votes && !votes.status) {
            return votes.find(item => item.personID === personID && moment(item.dateCreated).isBetween(moment().add(-1, 'days').startOf('day'), moment().add(-1, 'days').endOf('day')));
        }
    }

    watch(followLevel) {
        this.props.onFollow(this.props.polly.personID, this.props.currentPollyId, this.state.followeeType, followLevel);
        this.setState({
            followLevel: followLevel
        })
    }

    onUnFollow() {
        this.props.onUnFollow(this.props.polly.personID, this.state.followeeType);
        this.setState({
            followLevel: 0
        })
    }

    onWatchClick(ev) {
        ev.preventDefault();
        this.watch(this.state.isWatch)
        if (!this.state.voterLocation && this.props.currentUser) {
            this.setState({
                isVoterLocationModal: true,
            })
        } else {
            this.setState({isAuthModalOpen: !this.props.currentUser});
        }
    }

    onWatchCloselyClick(ev) {
        ev.preventDefault();
        this.watch(this.state.isWatchClosely)
        if (!this.state.voterLocation && this.props.currentUser) {
            this.setState({
                isVoterLocationModal: true,
            })
        } else {
            this.setState({isAuthModalOpen: !this.props.currentUser});
        }
    }

    privacyModal(val) {

        this.setState({
            privacyFor: val,
            privacyModal: !this.state.privacyModal,
        })
    }

    pollyEditCancel = (val) =>{
        this.setState({
            pollyEditModal: !this.state.pollyEditModal
        })
    }

    onChange(e) {
        const state = this.state;
        if ( e.target.name === "isFinal") {
            state[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
        }else if(e.target.name === "polliesComment"){
            const text = e.target.value;
            const textLength = text.length;
            if (textLength <= COMMENT_MAX_CHARACTER) {

                state[e.target.name] = e.target.value
                state['chars_left'] = textLength
            }
        } else {
            state[e.target.name] = parseInt(e.target.value);
        }
        this.setState(state);
        if (!this.state.voterLocation && this.props.currentUser) {
            this.setState({
                isVoterLocationModal: true,
            })
        } else {
            this.setState({isAuthModalOpen: !this.props.currentUser});
        }
    }

    onComment(e) {
        const text = e.target.value;
        const textLength = text.length;
        if (textLength <= COMMENT_MAX_CHARACTER) {
            this.setState({
                [e.target.name]: [e.target.value]
            });
            this.setState({chars_leftBody:textLength})
        }
    }

    onSubmit = () => {
        const currentUser = this.props.currentUser;
        const commentAdd = {
            "id": "",
            "personID": this.props.polly && this.props.polly.personID || '',
            "body": "",
            "viewMyPostsAndComments": this.state.viewMyPostsAndComments || 0,
            "viewMyVotes": this.state.viewMyVotes || 0,
            "replyMyPostsAndComments": this.state.replyMyPostsAndComments || 0,
            "viewMyPostsAndCommentsDefault": currentUser ? currentUser.viewMyPostsAndComments : null,
            "replyMyPostsAndCommentsDefault": currentUser ? currentUser.replyMyPostsAndComments : null,
            "Anonymous": JSON.parse(localStorage.getItem("AnonymousMode"))
        }

        if (this.state.commentBody && this.state.commentBody[0]) {
            commentAdd["body"] = this.state.commentBody[0];
            this.props.addComments(this.props.polly.personID, commentAdd);
        }
        this.setState({
            commentBody: ''
        })
    }

    onMouseOver(e) {
        if (e.target && e.target.id === 'watch') {
            this.setState({
                watchHover: true,
            })
        } else if (e.target && e.target.id === 'watchClosely') {
            this.setState({
                watchCloselyHover: true,
            })
        }
    }

    onMouseOut(e) {
        if (e.target && e.target.id === 'watch') {
            this.setState({
                watchHover: false,
            })
        } else if (e.target && e.target.id === 'watchClosely') {
            this.setState({
                watchCloselyHover: false,
            })
        }
    }

    getDisplayNameFromMentions = (userName) => {
        const mention = this.props.mentions;
        if (mention && mention.length) {
            const mentionUser = mention.find(res => res.id === userName);
            return mentionUser.display
        }
        return userName;
    }

    parseBody = body => {
        var matchedMentions = body.match(/\[~(.*?)\]/g);
        let content = body;
        if (matchedMentions && matchedMentions.length > 0) {
            matchedMentions.map(res => {
                const userName = res.match(/\[~(.*?)\]/).pop();
                const displayName = this.getDisplayNameFromMentions(userName);
                content = content.replace(res, `<a href=/@${userName}>${displayName}</a>`);
            })
        }
        return {__html: content};
    }
    toggleChat = () => {
        const { currentUser } = this.props;
        console.log(currentUser,"currentUser")

        if (!currentUser) {
            this.setState({ isAuthModalOpen: true });
        } else {
            this.setState((prevState) => ({
                showChat: !prevState.showChat
            }));
        }
    };
    openModal = () => {
        this.setState({isOpen: !this.state.isOpen})
    }


    handlePollyEdit = () =>{
        this.setState({
            pollyEditModal:true
        })
    }

    onCloseAuthModal = () => {
        this.setState({
            isAuthModalOpen: false
        })
    }

    voterLocationAdded = () => {
        this.setState({
            isVoterLocationModal: false,
            voterLocation: true
        })
    }

    onCloseShare = () => {
        this.setState({showShare: false})
    }

    handleDeletePollyComment = async (id) => {
        let formData = new FormData();
        let data = {}
        data.EntityId = id
        data.EntityType = "PollyComment"
        for (const key in data) {
            formData.append(key, data[key]);
        }
        await agent.DeleteComment.deleteComment(formData).then(res => {
            this.props.fetchPollyCommentList(this.props.polly.personID);
        }).catch(err => console.log('Oh no!', err));
    }

    handleReaction = (name, id, authorID) => {
        const data = this.state.reaction.filter(item => item.id === id && item.name === name)
        if (!data.length) {
            this.setState(prevState => ({
                reaction: [
                    ...prevState.reaction,
                    {id, name}
                ]
            }))
        }
        this.props.abuse({
            "EntityId": id,
            "EntityType": "DailyVoteComment",
            "AbuseType": name,
            "AuthorId": authorID,
        });
    };

    handleReportAbuse = () =>{
        message.error(getLabel(338));
    }


    render() {
        const { showChat } = this.state;
        let privacyArray = [getLabel(71), getLabel(72), getLabel(73), getLabel(78),getLabel(312)];
        const {
            displayName, twitter, facebookPage, youTube, gender, photoName, bio, urlSlug,chat_status,typePage,lastTermTitle,language,
            lastOfficeTitle, personID,seoDescription , seoKeywords, seoTitle, lastOfficeProvinceName, lastPartyName, lastPartyURLSlug, photoTitle, photoSource, photoAuthor
        } = this.props.polly;
        const displayLocation = this.props.polly?.Author?.displayLocation;
        const Name = this.props.polly?.Author?.displayName;
        const isOwner = this.props?.currentUser?.id &&
            this.props.polly.userId &&
            this.props?.currentUser?.id === this.props.polly.userId;

        const isAdmin = this.props?.currentUser?.roles?.[0] === "Admin";
        const isAvailable = chat_status === "online" || (chat_status === "demo" && (isOwner || isAdmin));
        const mayReportAbuse = this.props?.currentUser?.user_privilege?.mayReportAbuse;
        const UrlTest = /(www|http:|https:)+[^\s]+[\w]/.test(photoSource);
        const AuthorData = photoAuthor !== "NULL" ? photoAuthor : photoSource !== "NULL"? photoSource : null;
        //let isShow = this.state.prevVote && this.state.prevVote.dateCreated && !moment(this.state.prevVote.dateCreated).isBetween(moment().startOf('day'), moment().endOf('day')) || false;
        let yesterdayVoteId = this.getYesterDayVotesById(this.props.polly.personID, this.props.votes)
        const {userInfo, anonymousMode} = this.props;
        const {downVote, upVote, mayBe, vote, polliesComment, isAuthModalOpen, isFinal, reaction} = this.state;
        return (
            <div className="polly-container">
                <InfoModal isOpen={this.state.isOpen} onClose={this.openModal} title={getLabel(39)}
                           description={getLabel(112)}/>
                <UserModal isAuthModalOpen={isAuthModalOpen} onCloseAuthModal={this.onCloseAuthModal}/>
                {this.state.showShare && !this.props.anonymousMode &&
                <SharePostModal showShare={this.state.showShare} userInfo={this.props.currentUser}
                                onCloseShare={this.onCloseShare} polly={this.props.polly}/>}
                {
                    this.state.pollyEditModal &&
                    <PollyEditModal
                        pollyEditCancel={this.pollyEditCancel}
                        state={this.state}
                    />
                }
                {this.state.isVoterLocationModal &&
                <Modal show={this.state.isVoterLocationModal}
                       bsSize="large"
                       className="polly-modal"
                       aria-labelledby="contained-modal-title-lg"
                       onHide={this.openVotarLocationModel}>
                    <div id="votepopup">
                        <div className="modal-header">
                            <div className="row">
                                <div className="col-md-12">
                                    <h3>{getLabel(214)}</h3>
                                </div>
                            </div>
                            <button type="button"
                                    className="close"
                                    onClick={this.openVotarLocationModel}
                                    data-dismiss="modal"
                                    aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <VoterLocationsTab {...this.props} onVoterLocationAdded={this.voterLocationAdded}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>}

                {this.state.isPrivacyModal &&
                <Modal show={this.state.isPrivacyModal}
                       bsSize="large"
                       className="polly-modal"
                       aria-labelledby="contained-modal-title-lg"
                       onHide={this.openPrivacyModel}>
                    <div id="votepopup">
                        <div className="modal-header">
                            <div className="row">
                                <div className="col-md-12">
                                    <h3>{getLabel(265)}</h3>
                                </div>
                            </div>
                            <button type="button"
                                    className="close"
                                    onClick={this.openPrivacyModel}
                                    data-dismiss="modal"
                                    aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <PrivacySettingsTab/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>}
                {
                    this.state.privacyModal && this.state.privacyFor === 'viewMyVotes' &&
                    <PrivacyModal
                        onChange={this.onChange}
                        privacyModal={this.privacyModal}
                        selectedAudience={true}
                        viewMyVotes={true}
                        state={this.state}
                    />
                }
                {
                    this.state.privacyModal && this.state.privacyFor === 'viewMyPostsAndComments' &&
                    <PrivacyModal
                        onChange={this.onChange}
                        privacyModal={this.privacyModal}
                        viewMyPostsAndComments={true}
                        selectedAudience={true}
                        state={this.state}
                    />
                }
                <div className="container">
                    <Helmet>
                        <link rel="canonical" href={`${new URL(document.URL).origin}/${urlSlug}`}/>
                        <title>{seoTitle}</title>
                        <meta name="keywords" content={seoKeywords}/>
                        {/*<meta name="robots" content="index,follow"/>*/}
                        <meta name="description" content={seoDescription}/>
                    </Helmet>
                    <div className={`row politicians-row${anonymousMode ? "-dark cw" : ""}`}>
                        <div className="col-md-6 p-0">
                            <div className=' d-flex col-md-12'>
                                <div className='col-md-4 polly-page-image'>
                                    <img onError={e => e.target.src = Avatar}
                                         src={photoName ? `/images/people/${personID}/official/${photoName}` : Avatar}
                                         alt={photoTitle || "pollies-image"} title={photoTitle || "pollies-title"} className="politicians-vote-img border-radius-10" />
                                    <span className={`${parseInt(gender) === 1 && "female "}${parseInt(gender) === 2 && " male"}`}/>
                                </div>

                                <div className="col-md-5">
                                    <div className="politicians-text-card">
                                        <h1 className={`${anonymousMode ? "cw" : ""}`}>{displayName}</h1>
                                        <h2 className="occupation font-normal">
                                            {lastOfficeTitle} {this.props?.polly?.lastOfficeLevel !== 'City' &&
                                        <span className="occupation">{this.props?.polly?.lastOfficeCity || ''}</span>
                                        }{(lastOfficeTitle || this.props?.polly?.lastOfficeCity) && lastOfficeProvinceName ? ", " : ''}{lastOfficeProvinceName || ''}
                                        </h2>
                                        <Link to={`/${lastPartyURLSlug}`}>
                                            <span className="description">{lastPartyName || ''}</span>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-3 toolbar">
                                    <div>
                                        <button
                                            className={`btn  btn-default${anonymousMode ? "-dark" : ""} btn-polly-watch ${this.state.followLevel == 1 && 'active'}`}
                                            onClick={this.state.followLevel == 1 ? this.onUnFollow : this.onWatchClick}>
                                            <span className="polly-watching" id="watch" onMouseOver={this.onMouseOver}
                                                  onMouseOut={this.onMouseOut}>{this.state.followLevel == 1 ? (this.state.watchHover ? getLabel(88) : getLabel(89)) : getLabel(90)}</span>
                                        </button>
                                    </div>
                                    <div>
                                        <button
                                            className={`btn  btn-default${anonymousMode ? "-dark" : ""} btn-polly-watch ${this.state.followLevel == 2 && 'active'}`}
                                            onClick={this.state.followLevel == 2 ? this.onUnFollow : this.onWatchCloselyClick}>
                                            <span className="polly-watching" id="watchClosely"
                                                  onMouseOver={this.onMouseOver}
                                                  onMouseOut={this.onMouseOut}>{this.state.followLevel == 2 ? (this.state.watchCloselyHover ? getLabel(91) : getLabel(92)) : getLabel(93)}</span>
                                        </button>
                                    </div>
                                    <div>
                                        <a className={`btn btn-default${anonymousMode ? "-dark" : ""} btn-sm m-t-5`}
                                           title="help"
                                           onClick={this.openModal}>
                                            <i className={`fa fa-question-circle${anonymousMode ? "-dark" : ""} pol`}
                                               style={{fontSize: 15}}/>
                                        </a>
                                    </div>
                                    {(this.props?.currentUser?.id && this.props.polly.userId && this.props?.currentUser?.id === this.props.polly.userId || this.props?.currentUser?.roles[0] === "Admin" && !anonymousMode) &&
                                    <div>
                                        <button
                                            onClick={this.handlePollyEdit} className={`btn  btn-default${anonymousMode ? "-dark" : "" } btn-polly-watch`}>{getLabel(130)}
                                        </button>
                                    </div>}
                                    {(isAvailable && !anonymousMode) && (
                                        <button
                                            onClick={this.toggleChat} className={`btn ml-1 btn-default${anonymousMode ? "-dark" : "" } btn-polly-watch`}>
                                            <img src={Chat_icon} alt={Chat_icon} className="w-24 pollypageImage"/> {getLabel(488)}
                                        </button>)}
                                    {showChat && (
                                        <ChatModal
                                            show={showChat}
                                            onClose={this.toggleChat}
                                            currentUser={this.props.currentUser}
                                            polly={this.props.polly}
                                            displayLocation={displayLocation}
                                            Name={Name}
                                        />
                                    )}
                                </div>
                            </div>
                            {!this.props.polly.PersonHasUserAccount && (
                                <div className='ml-4'>
                                    <Link to={{
                                        pathname: `/Claim_My_Page/${urlSlug}`,
                                        state: {
                                            polly: this.props.polly,
                                            anonymousMode: this.props.anonymousMode
                                        }
                                    }}>
                                        {getLabel(493)}
                                    </Link>
                                </div>
                            )}
                            {photoSource && photoAuthor && photoAuthor !== "NULL" && photoSource !== 'NULL' ? <span className='ml-4 source-img'>Source: {UrlTest ?
                                <a href={photoSource}
                                   target='_blank'>{photoAuthor}</a> : `${photoAuthor} @ ${photoSource}`}</span> :
                                AuthorData ? `Source: ${AuthorData}`  :
                                    null}
                            <div className="col-md-12">
                                {facebookPage &&
                                <a href={`https://www.facebook.com/${facebookPage}`} target="_blank"
                                   className="fa-icon fa fa-facebook"/>}
                                {twitter && <a href={`https://twitter.com/${twitter}`} target="_blank"
                                               className="fa-icon fa fa-twitter"/>}
                                {youTube && <a href={`https://www.youtube.com/${youTube}`} target="_blank"
                                               className="fa-icon fa fa-youtube"/>}
                                <div className="social-share">
                                    <p className="description">{bio}</p>
                                </div>
                                {/* <div className="checkdiv"><input type="checkbox" name="allow_messages" id="allow_messages" />
                                        <label for="allow_messages">Allow this person to send me mails/direct messages</label>
                                     </div> */}
                            </div>
                            {/*</div>*/}
                        </div>
                        <div className="col-md-6">
                            <h4 className={` m-l-15 handwritten ${anonymousMode ? "cw" : ""}`}>{getLabel(113)}</h4>
                            <div className="bs-callout bs-callout-default">
                                <div className={`row ${anonymousMode ? "bgl cw" : ""}`}>
                                    <div className="col-md-12">
                                        <div className="previousvote">
                                            {
                                                yesterdayVoteId &&
                                                <div>
                                                    {getLabel(114)}<b>{yesterdayVoteId.vision.toFixed(1)}</b> {getLabel(110)} :<b>{yesterdayVoteId.ability.toFixed(1)}</b>
                                                </div>
                                            }
                                            {
                                                this.state.prevVote && this.state.prevVote.dateCreated &&
                                                <VoteItem
                                                    title={getLabel(115) + (this.state.prevVote && moment(this.state.prevVote.dateCreated).format('MMMM D, YYYY ')) + getLabel(100)}
                                                    {...this.state.prevVote}
                                                    polliesComment={polliesComment}
                                                    disabled={true}
                                                    downVote={downVote}
                                                    upVote={upVote}
                                                    mayBe={mayBe}
                                                    vote={vote}
                                                    isFinal={isFinal}
                                                    anonymous={this.props.anonymousMode}
                                                    charsLeft={this.state.chars_left}
                                                    maxChar={this.state.max_char}
                                                />
                                            }
                                            {
                                                !(this.state.prevVote && this.state.prevVote.dateCreated) &&
                                                <VoteItem title={getLabel(101)}
                                                          {...this.state.curVote}
                                                          show={true}
                                                          onAbilityChange={this.handleOnChange}
                                                          onVisionChange={this.handleOnChange}
                                                          onLikeSubmit={this.onLikeSubmit}
                                                          onChange={this.onChange}
                                                          polliesComment={polliesComment}
                                                          downVote={downVote}
                                                          upVote={upVote}
                                                          mayBe={mayBe}
                                                          vote={vote}
                                                          anonymous={this.props.anonymousMode}
                                                          isFinal={isFinal}
                                                          charsLeft={this.state.chars_left}
                                                          maxChar={this.state.max_char}
                                                />
                                            }

                                        </div>
                                        {
                                            this.state.prevVote && this.state.prevVote.dateCreated &&
                                            <div className="m-t-15">
                                                <b className="m-l-15">{getLabel(116)}</b>
                                            </div>
                                        }
                                        {
                                            !(this.state.prevVote && this.state.prevVote.dateCreated) && this.props.isAuthorized &&
                                            <div className="row">
                                                <div className="col-md-12 m-b-20 ">
                                                    <p className="red">{this.props.voteError}</p>
                                                    <div className="pull-right">
                                                        <a onClick={() => this.privacyModal('viewMyVotes')}
                                                           className="small privacylink m-r-20" data-toggle="modal"
                                                           data-target="#privacysettings">
                                                            <i className="mdi mdi-glasses"/>{getLabel(105)}</a>
                                                        <button
                                                            className={`btn smallmargintop text-whitewaves-effect waves-light btn-primary${anonymousMode ? "-dark" : ""}`}
                                                            onClick={this.onVoteSubmit}
                                                            // disabled={this.state.prevVote && this.state.prevVote.dateCreated || !vote}
                                                        >
                                                            {getLabel(106)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {this.state.prevVote && this.state.prevVote.dateCreated &&
                                        <div className="handwritten" style={{
                                            color: '#ec1c45',
                                            padding: '10px 15px'
                                        }}>{this.state.prevVote.viewMyVotes !== 0 ? privacyArray[parseInt(this.state.prevVote.viewMyVotes) - 1] : privacyArray[4]} {getLabel(104)}</div>}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row subfooter">
                        <div className="col-md-4">
                            <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(118)}</h3>
                                <fieldset className="form-group m-t-5 m-b-30">
                                    {this.props.commentsList && this.props.commentsList.length === 0 &&
                                    <label style={{fontWeight: "unset"}}>{getLabel(272)}</label>}
                                    <textarea className={`form-control${anonymousMode ? "-dark" : ""} form-control-lg`}
                                              rows="8"
                                              name="commentBody"
                                              placeholder={getLabel(109)}
                                              value={this.state.commentBody || ''}
                                              onChange={this.onComment}
                                    />
                                    <span className="max-counter">{this.state.chars_leftBody}/{COMMENT_MAX_CHARACTER}</span>
                                    <hr/>
                                    {
                                        this.props.isAuthorized &&
                                        <div className="float-right">
                                            <a onClick={() => this.privacyModal('viewMyPostsAndComments')}
                                               className="small privacylink m-r-20" data-toggle="modal"
                                               data-target="#privacysettings">
                                                <i className="mdi mdi-glasses"/>{getLabel(105)}
                                            </a>
                                            <button
                                                className={`btn btn-lg btn-primary${anonymousMode ? "-dark" : ""} float-right`}
                                                onClick={this.onSubmit}>{getLabel(106)}</button>
                                        </div>
                                    }
                                    {
                                        !this.props.isAuthorized && <div style={{textAlign: 'right'}}><Link
                                            to={'/register'}>{getLabel(11)}</Link> {getLabel(120)}</div>
                                    }
                                </fieldset>
                                <div className="comments" id="comment-section">
                                    {
                                        (this.props.commentsList || []).map(comment => {
                                            let commentDate = moment(comment.dateCreated).format("YYYY-MM-DD")
                                            return (
                                                <div className="comment" key={comment.id} data-id={comment.id}>
                                                    <header>
                                                        <div className="facebook-reaction col-md-2 fr">
                                                            {mayReportAbuse ?  <span className="like-btn">
                                            <span
                                                className="like-btn-text">Abuse?</span>
                                                <ul className={`${this.props.anonymousMode ? "reactions-box-dark" : "reactions-box"}`}>
                                                    <span className="reaction reaction-vulgar" onClick={() => {
                                                        this.handleReaction("Vulgar", comment.id, comment.author.id)
                                                    }} data-reaction="Vulgar"/>
                                                    <span className="reaction reaction-irrelevant" onClick={() => {
                                                        this.handleReaction("Irrelevant", comment.id, comment.author.id)
                                                    }} data-reaction="Irrelevant"/>
                                                    <span className="reaction reaction-pointless" onClick={() => {
                                                        this.handleReaction("Pointless", comment.id, comment.author.id)
                                                    }} data-reaction="Pointless"/>
                                                </ul>
                                            </span> : <span className="like-btn-text" onClick={()=>this.handleReportAbuse()}>Abuse?</span>}
                                                            <div className="like-stat">
                                                                <span
                                                                    className="like-emo">{reaction && reaction.map((items) => (items.id === comment.id ?
                                                                    <span
                                                                        className={`like-btn-${items.name || ""}`}/> : ""))}
                                                                </span>
                                                                <span className="like-details">you</span>
                                                            </div>
                                                            <div className="delete-comment">
                                                                {
                                                                    this.props?.currentUser?.roles[0] === "Admin" &&
                                                                    <div style={{ marginLeft: 70, clear: 'both', whiteSpace: 'nowrap' }}>
                                                                        <Popconfirm placement="bottomLeft" title={getLabel(310)} onConfirm={() => this.handleDeletePollyComment(comment.id)} okText="Yes" cancelText="No">
                                                                            <div style={{display: "flex", alignItems: "center", color:"#43c5e6"}}>
                                                                                <i className="fa fa-trash"/>
                                                                            </div>
                                                                        </Popconfirm>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="authorimage">
                                                            <div className="authorimage">
                                                                . {userInfo ?
                                                                <a className="politician">
                                                                    <PostAvatar
                                                                        userName={userInfo[comment.authorId] && userInfo[comment.authorId].userName || ''} isAnonymous={comment.anonymous}/>
                                                                    <span
                                                                        className={userInfo[comment.authorId]?.isVerified ? "gender verified" :  `${userInfo[comment.authorId] && parseInt(userInfo[comment.authorId].gender) === 1 && " female "}${userInfo[comment.authorId] && parseInt(userInfo[comment.authorId].gender) === 2 && " male"}`}/>
                                                                </a> : <a className="politician">
                                                                    <PostAvatar
                                                                        userName={comment.author && comment.author.userName || ''} isAnonymous={comment.anonymous}/>
                                                                    <span
                                                                        className={`${parseInt(comment.author && comment.author.gender) === 1 && "female "}${parseInt(comment.author && comment.author.gender) === 2 && "male"}`}/>
                                                                </a>
                                                            }
                                                            </div>
                                                        </div>

                                                        <div className="articletitle">
                                                            {
                                                                userInfo ?
                                                                    <div className="author">
                                                                        {userInfo[comment.authorId] &&
                                                                        (comment.anonymous ? <Link to="">{getLabel(284)}</Link> :<Link
                                                                            to={`/@${userInfo[comment.authorId].userName}`}>
                                                                            {userInfo[comment.authorId].displayName}, {userInfo[comment.authorId].displayLocation}</Link>)}
                                                                    </div> :
                                                                    <div className="author">
                                                                        {comment.anonymous ? <a>{getLabel(284)}</a> : <a>{comment.author && comment.author.displayName || "User"}, {comment.author && comment.author.displayLocation}</a>}
                                                                    </div>
                                                            }
                                                            <div
                                                                className="date m-0">{comment.dateCreated && new Date(comment.dateCreated).toDateString() + " " + new Date(comment.dateCreated).toLocaleTimeString('en-US')}</div>
                                                            <div className="row">
                                                                <div className="col-sm-10">
                                                                    <div className="mainpolinfo">
                                                                        <div className="polscores">
                                                                            {
                                                                                comment.vision >= 0 && comment.vision !== null &&
                                                                                <div className="row">
                                                                                    <div
                                                                                        className="col-md-3 vote-col-name"
                                                                                        style={{padding: '5px 0'}}>
                                                                                        <span>{getLabel(111)}</span>
                                                                                    </div>
                                                                                    <div className="col-md-7 vision">
                                                                                        <Slider
                                                                                            min={0}
                                                                                            max={10}
                                                                                            value={comment.vision}
                                                                                            orientation="horizontal"
                                                                                        />
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-2 vote-col-name">
                                                                                        <span
                                                                                            className="result">{comment.vision}</span>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            {
                                                                                comment.ability >= 0 && comment.ability !== null &&
                                                                                <div className="row">
                                                                                    <div
                                                                                        className="col-md-3 vote-col-name"
                                                                                        style={{padding: '5px 0'}}>
                                                                                        <span>{getLabel(110)}</span>
                                                                                    </div>
                                                                                    <div className="col-md-7 ability">
                                                                                        <Slider
                                                                                            min={0}
                                                                                            max={10}
                                                                                            value={comment.ability}
                                                                                            orientation="horizontal"
                                                                                        />
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-2 vote-col-name">
                                                                                        <span
                                                                                            className="result">{comment.ability}</span>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    comment.vote &&
                                                                    <div className="col-sm-2">
                                                                        {comment.vote === "F" &&
                                                                        <img src={up_vote} width="40" height="40"
                                                                             alt="upVote"/>}
                                                                        {comment.vote === "U" &&
                                                                        <img src={undecided_vote} width="40" height="40"
                                                                             alt="unDecidedVote"/>}
                                                                        {comment.vote === "A" &&
                                                                        <img src={down_vote} width="40" height="40"
                                                                             alt="downVote"/>}
                                                                    </div>
                                                                }
                                                                <div className="col-sm-12" style={{padding: '5px 5px'}}>
                                                                    <div className="text-comment">
                                                                        <Link
                                                                            to={`/vote/${urlSlug}/${comment.author && comment.author.userName}/${commentDate}`}>
                                                                            {comment.body}
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </header>
                                                </div>
                                            );
                                        })
                                    }

                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(121)}</h3>
                                <div className="comments inthenews">
                                    {(this.props.newsList || []).map((item, i) => {
                                        return (
                                            <div key={i} className="comment pointer">
                                                <Link to={`/posts/${item.slug}`}>
                                                    <header>
                                                        <div className="authorimage"><a href="#">{item && <PostAvatar
                                                            userName={item.authorUserName || item.author && item.author.userName || ''}/>}</a>
                                                        </div>
                                                        <div className="articletitle">
                                                            <div className="text">
                                                                <a style={{color: '#000000', fontWeight: 'lighter'}}>
                                                                    <div style={{fontSize: 13}}
                                                                         dangerouslySetInnerHTML={this.parseBody(item.body)}/>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </header>
                                                </Link>
                                                <div className="date hidden">{getLabel(122)}</div>
                                            </div>
                                        )
                                    })
                                    }
                                    {
                                        (this.props.newsList || []).length === 0 &&
                                        <div>{getLabel(123)}</div>
                                    }

                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 ">
                            {this.props.polly?.PersonHasUserAccount ?
                                <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                    <h4 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(463)}</h4>
                                    <ul>
                                        {
                                            this.state?.inTheirOwnWords?.length && this.state.inTheirOwnWords.map((item, i) => {
                                                return (
                                                    <li key={i}>
                                                        <div className="politician">
                                                            {/*<img onError={e => e.target.src = Avatar}*/}
                                                            {/*     src={item.photoName ? `/images/people/${item.personID}/official/${item.photoName}` : Avatar}*/}
                                                            {/*     alt="" width="128" height="128"*/}
                                                            {/*     className="img-circle border-radius-10"/>*/}
                                                            {/*<span className="poli-info">*/}
                                                            {/*<span*/}
                                                            {/*    className={`${parseInt(item.gender) === 1 && "gender female "}${parseInt(item.gender) === 2 && " gender male"}`}/>*/}
                                                            <div className="poliname">
                                                                {/*<Link to={`/${item?.urlCheck}/${item?.slug}`}>*/}
                                                                <div style={{ fontWeight: 'bold' }}>
                                                                    {item?.title}
                                                                </div>
                                                            </div>
                                                            {<span >{item.body.length > 200 ?
                                                                `${item.body.substring(0, 200)}...` : item.body
                                                            }{item.body.length > 200 ? <Link to={`/${item?.urlCheck}/${item?.slug}`} className="link-to-post">{getLabel(457)}</Link> : ""}</span>}
                                                        </div>
                                                        <hr/>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </div>
                                :
                                <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                    <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(124)}</h3>
                                    <ul>
                                        {
                                            (this.props.relatedPolliciesList || []).map((item, i) => {
                                                return (
                                                    <li key={i}>
                                                        <Link to={`/${item.urlSlug}`} className="politician">
                                                            <img onError={e => e.target.src = Avatar}
                                                                 src={item.photoName ? `/images/people/${item.personID}/official/${item.photoName}` : Avatar}
                                                                 alt="" width="128" height="128"
                                                                 className="img-circle border-radius-10"/>
                                                            <span className="poli-info">
                                                            <span
                                                                className={`${parseInt(item.gender) === 1 && "female "}${parseInt(item.gender) === 2 && "male"}`}/>
                                                            <span className="poliname">
                                                                <Link to={`/${item.urlSlug}`}>
                                                                    {item.displayName}
                                                                </Link>
                                                            </span>
                                                            <span
                                                                className={`occupation ${anonymousMode ? "cw" : ""}`}>{item.lastOfficeTitle}</span>
                                                            <span
                                                                className="country">{item.lastOfficeCountryName}</span>
                                                        </span>
                                                        </Link>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </div> }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PollyPage.propTypes = {
    polly: PropTypes.object.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PollyPage);
